import styled from "styled-components";
import { deviceSizesMin } from "../../DeviceSizes";

export const WarningBannerContainer = styled.div`
  text-align: center;
  background-color: #ff6666;
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: normal;
  font-size: 15px;

  flex-direction: column;

  @media only screen and ${deviceSizesMin.laptop} {
    min-height: 40px;
    font-size: 20px;
  }
`;
